module.exports = __webpack_public_path__ + "img/wenxin.4f7be43e.jpg";